var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticClass:"bg-alert-success",attrs:{"show":""}},[_c('p',{staticClass:"p-2 jumbo-text"},[_vm._v(" "+_vm._s(_vm.$t('invitation.openCampaign', {total_contents: _vm.total_contents}))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }